module.exports = __webpack_public_path__ + "img/law4-m@1.cc4e6f52.jpg";